import React from "react";
import "./newLabel.scss";

export class NewLabel extends React.Component {
    render() {
        return <div className="new-label">Nowość</div>;
    }
}

